import React from "react";
import { CalendarCheck } from "lucide-react";

export function Logo({ size = "md", showText = true, className = "" }) {
  const iconSizes = { sm: "h-7 w-7", md: "h-9 w-9", lg: "h-11 w-11" };
  const textSizes = { sm: "text-base", md: "text-lg", lg: "text-2xl" };
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <span className={`inline-flex items-center justify-center rounded-lg bg-blue-600 text-white ${iconSizes[size]}`}>
        <CalendarCheck className="h-[60%] w-[60%]" strokeWidth={2.4} />
      </span>
      {showText && (
        <span className={`font-bold tracking-tight text-slate-900 ${textSizes[size]}`}>Syllabify</span>
      )}
    </div>
  );
}
